import { observer } from 'mobx-react';
import * as React from 'react';
import { BsQuestionCircle } from '@react-icons/all-files/bs/BsQuestionCircle';

export interface IHelpLinkProps {
    readonly url: string;
    readonly className?: string;
}

@observer
export class HelpLink extends React.Component<IHelpLinkProps> {
    public render() {
        return (
            <a className={'btn-link ' + this.props.className} href={this.props.url} target="_blank">
                <BsQuestionCircle style={{ fontSize: 21 }} />
            </a>
        );
    }
}
